interface IconProps {
  name: string;
  isMobile?: boolean;
  size?: number; // 默认大小，宽高相等
  width?: number; // 可单独传宽度
  height?: number; // 可单独传高度
  className?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  title?: string;
  // 透传 data-qt / data-qt-* 等埋点属性到 svg 上，供全局点击代理识别
  [dataAttr: `data-${string}`]: unknown;
}

export default function Icon({
  name,
  isMobile = false,
  size = 18,
  width,
  height,
  className = "",
  onClick,
  title,
  ...rest
}: IconProps) {
  const id = `#icon-${isMobile ? "mobile-" : ""}${name}`;

  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      className={className}
      onClick={onClick}
      role="img"
      aria-label={title}
      {...rest}
    >
      {title && <title>{title}</title>}
      <use xlinkHref={id} />
    </svg>
  );
}
